import { InteractionManager, Platform } from 'react-native';

type IdleWindow = Window & {
  requestIdleCallback?: (
    callback: IdleRequestCallback,
    options?: IdleRequestOptions,
  ) => number;
  cancelIdleCallback?: (handle: number) => void;
};

export function scheduleAfterFirstPaint(task: () => void) {
  let cancelled = false;
  let animationFrameId: number | null = null;
  let timeoutId: ReturnType<typeof setTimeout> | number | null = null;
  let idleCallbackId: number | null = null;
  let interactionHandle: { cancel?: () => void } | null = null;

  const runTask = () => {
    if (cancelled) {
      return;
    }

    task();
  };

  if (Platform.OS === 'web') {
    if (typeof window === 'undefined') {
      timeoutId = setTimeout(runTask, 0);
    } else {
      animationFrameId = window.requestAnimationFrame(() => {
        const idleWindow = window as IdleWindow;
        if (typeof idleWindow.requestIdleCallback === 'function') {
          idleCallbackId = idleWindow.requestIdleCallback(runTask, { timeout: 400 });
          return;
        }

        timeoutId = window.setTimeout(runTask, 0);
      });
    }
  } else {
    interactionHandle = InteractionManager.runAfterInteractions(() => {
      animationFrameId = requestAnimationFrame(runTask);
    });
  }

  return () => {
    cancelled = true;

    if (animationFrameId != null) {
      if (Platform.OS === 'web' && typeof window !== 'undefined') {
        window.cancelAnimationFrame(animationFrameId);
      } else {
        cancelAnimationFrame(animationFrameId);
      }
    }

    if (timeoutId != null) {
      clearTimeout(timeoutId);
    }

    if (idleCallbackId != null && typeof window !== 'undefined') {
      const idleWindow = window as IdleWindow;
      idleWindow.cancelIdleCallback?.(idleCallbackId);
    }

    interactionHandle?.cancel?.();
  };
}
